import React, { forwardRef } from 'react'
import { clsx } from 'clsx'
import { Text } from 'ui/src/components/Text/Text'
import { root } from './DiscountTooltip.css'

export type DiscountTooltipProps = {
  className?: string
  children?: string
  subtitle?: string | React.ReactNode
  color?: 'green' | 'gray'
  orientation?: 'top' | 'bottom'
}

export const DiscountTooltip = forwardRef<HTMLDivElement, DiscountTooltipProps>(
  ({ className, children, subtitle, color = 'green', orientation = 'top' }, ref) => {
    return (
      <div ref={ref} className={clsx(root[color], className)} data-orientation={orientation}>
        {children && (
          <Text size="xs" color="textPrimary" align="center">
            {children}
          </Text>
        )}
        {subtitle && (
          <Text size="xs" color={color === 'green' ? 'signalGreenText' : 'textSecondary'} align="center">
            {subtitle}
          </Text>
        )}
      </div>
    )
  },
)
DiscountTooltip.displayName = 'DiscountTooltip'
